<mat-card>
    <mat-card-header>
      <h3>Cadastro de Editais</h3>
  
      <button mat-icon-button (click)="incluir()" >
        <mat-icon>search</mat-icon>
      </button>
    </mat-card-header>
  
  
    <mat-card-content>
  
      <div fxLayout="row wrap" fxLayoutAlign="space-between start" fxLayoutGap="30px" >
        <mat-form-field >
          <mat-label>Filtrar</mat-label>
          <input matInput (keyup)="filtrar($event)" [formControl]="dataTableFieldFilter" placeholder="Ex. LIVRE" #input >
          <mat-icon matSuffix>filter_list</mat-icon>
          <mat-hint align="start">Filtra a tabela em todas as colunas</mat-hint>
        </mat-form-field>
      </div>
  
      
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" >
  
  
        <ng-container matColumnDef="data">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> DATA </th>
          <td mat-cell *matCellDef="let e"> {{e.data}} </td>
        </ng-container>
  
        <ng-container matColumnDef="numero" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> NUMERO </th>
          <td mat-cell *matCellDef="let e" > {{e.numero}} </td>
        </ng-container>
        <!--
        <ng-container matColumnDef="modalidade" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> MODALIDADE </th>
          <td mat-cell *matCellDef="let e" > {{e.modalidade}} </td>
        </ng-container>
  
        <ng-container matColumnDef="agrupamento" >
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> AGRUPAMENTO </th>
          <td mat-cell *matCellDef="let e" > {{e.agrupamento}} </td>
        </ng-container>
        -->
        <ng-container matColumnDef="titulo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> TITULO </th>
          <td mat-cell *matCellDef="let e"> {{e.titulo}} </td>
        </ng-container>
  
        <ng-container matColumnDef="processo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> PROCESSO </th>
          <td mat-cell *matCellDef="let e"> {{e.processo}} </td>
        </ng-container>
  
        <ng-container matColumnDef="sei">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after"> SEI </th>
          <td mat-cell *matCellDef="let e"> {{e.sei}} </td>
        </ng-container>
  
        <ng-container matColumnDef="detalhamento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="after">EDITAL </th>
          <td mat-cell *matCellDef="let e">
  
            <button mat-icon-button (click)="goToAlterar(e)">
              <mat-icon>edit</mat-icon>
            </button>
  


  
            <button mat-icon-button (click)="goToExcluir(e)">
              <mat-icon>delete</mat-icon>
            </button>
        </td>
          
          </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="colunas"></tr>
        <tr mat-row *matRowDef="let row; columns: colunas;"></tr>
  
      </table>
  
      <mat-paginator [pageSizeOptions]="[10]" showFirstLastButtons></mat-paginator>
  
      <button type="button" mat-raised-button name="retorna" color="warn" (click)="incluir()" >
        Novo Edital
      </button>

        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;
        &nbsp;


      <button type="button" mat-raised-button name="retornar" color="warn" layout-align-xs  (click)="retornar()" >
        Retornar
      </button>

    </mat-card-content>
    &nbsp;
    &nbsp;
    &nbsp;
    &nbsp;
    &nbsp;
  
    </mat-card>
  
  
  <p>
  <p>
  <p>
  
